export default function About() {
  return <section className="about" id="about">
    <div>
      <p className="eyebrow">The person behind the code</p>
      <h2>Hi, I’m Benjamin.</h2>
      <p className="credential">Seattle, WA · B.S. Computer Science, UW</p>
    </div>
    <div className="bio">
      <p>I’m a software engineer who enjoys making complicated systems easier to use. I work across web, mobile, and cloud infrastructure to turn ideas into useful products.</p>
      <p>My interest in software started with automation: finding the repetitive task, removing the friction, and making a little more room for the work that matters.</p>
    </div>
  </section>;
}
